


























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import router from '../../router';
import storage from 'baimahu/storage';
const uuidv4 = require('uuid/v4');
const { VUE_APP_API } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/weixin/mina/banner/index`,
  up_sort: `${VUE_APP_API}/qy/weixin/mina/banner/upSort`,
  up: `${VUE_APP_API}/qy/weixin/mina/banner/up`,
  down: `${VUE_APP_API}/qy/weixin/mina/banner/down`,
};
const TYPE_LIST = {
  1: '小程序',
  2: '不跳转',
};
const STATUS_LIST = {
  1: '待处理',
  2: '已处理',
  3: '下架',
};

@Component
export default class CarouselList extends Vue {
  isLoading: boolean = false;
  tableData: any = [];
  type_list: any = TYPE_LIST;
  status_list: any = STATUS_LIST;
  page: number = 1;
  is_down: boolean = false;
  is_up: boolean = false;
  banner_item: any = {};

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  query(page: number = 1) {
    this.isLoading = true;
    this.page = page;
    return this.$axios
      .get(`${API.query}?page=${page}`)
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          console.debug(remote.message);
          return;
        }
        this.tableData = remote.data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  addCarousel() {
    this.$router.push('/operation/carousel-detail/0');
  }

  upload(item: any) {
    storage.setItem('banner:item', item);
    this.$router.push(`/operation/carousel-detail/${item.id}`);
  }

  upBannerButton(item: any) {
    this.banner_item = item;
    this.is_up = true;
  }

  downBannerButton(item: any) {
    this.banner_item = item;
    this.is_down = true;
  }

  upBanner() {
    this.$axios.post(API.up, { id: this.banner_item.id }).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        console.debug(remote.message);
        return;
      }
      this.is_up = false;
      this.query(this.page);
    });
  }

  downBanner() {
    this.$axios.post(API.down, { id: this.banner_item.id }).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        console.debug(remote.message);
        return;
      }
      this.is_down = false;
      this.query(this.page);
    });
  }

  changeSort(item: any) {
    if (item.sort === 1) {
      return;
    }
    this.$axios.post(API.up_sort, { id: item.id }).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        console.debug(remote.message);
        return;
      }
      this.query(this.page);
    });
    // 更改顺序，表格重新排序
  }
  async created() {
    await this.query(this.page);
  }
}
